import { render } from "./ShippingAddressReport.vue?vue&type=template&id=b0e467c8&ts=true"
import script from "./ShippingAddressReport.vue?vue&type=script&lang=ts"
export * from "./ShippingAddressReport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__